export const poolData = () => ({
    UserPoolId: process.env.USER_POOL_ID, // Proporcione el suyo
    ClientId: process.env.CLIENT_ID // Proporcione el suyo
});

export const urlbase = process.env.URL_BASE

export const urlBaseEdukando = process.env.URL_BASE_EDUKANDO

export const urlBaseEdukandoLabtica = process.env.URL_BASE_EDUKANDO_LAB

